/**
 * Invite panel (INVENTORY §2 row 12; prototype template lines 651-662).
 *
 * NOT AN OVERLAY — an inline panel inside the Friends admin section.
 * `App.tsx` does not mount it; `screens/Crew.tsx` renders it in place when
 * `crewVM().hasInvite`, so this component does not re-check the gate.
 *
 * DEVIATION D-03: this panel is the ONLY place the generated code is ever
 * shown. Nothing stores it — `crewVM().copyValue` on the admin rows carries
 * identity only — so dismissing the panel really does discard the code, and
 * RESET PW is the only way to get another one.
 */

import type { CSSProperties } from 'react';

import { useQd } from '../store/index.ts';
import { copy } from '../store/selectors.3b.ts';
import { crewVM } from '../store/selectors.ts';

const CHIP: CSSProperties = {
  border: '1px solid var(--gt-border-2)',
  color: 'var(--gt-text-3)',
  fontFamily: 'var(--gt-font-mono)',
  fontSize: '9.5px',
  padding: '11px 10px',
  cursor: 'pointer',
};

export default function InvitePanel(): JSX.Element {
  const s = useQd();
  const v = crewVM(s);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        border: '1px solid var(--acc)',
        background: 'var(--accSoft)',
        padding: '13px 12px',
      }}
    >
      <div style={{ fontFamily: 'var(--gt-font-pixel)', fontSize: '7px', color: 'var(--acc)' }}>
        INVITE READY — <span>{v.invName}</span>
      </div>
      {/* The line that was missing. A display name is not a login — the server
          strips it to [a-z0-9] and bumps on collision — so handing over the
          name sent people to somebody else's account and refused them. */}
      <div style={{ fontFamily: 'var(--gt-font-mono)', fontSize: '10.5px', color: 'var(--gt-text-2)' }}>
        SIGNS IN AS: <span style={{ color: 'var(--acc)' }}>{v.invKey}</span>
      </div>
      <div style={{ fontFamily: 'var(--gt-font-mono)', fontSize: '10.5px', color: 'var(--gt-text-2)' }}>
        TEMP PASSWORD: <span style={{ color: 'var(--acc)' }}>{v.invPw}</span>
      </div>
      <div
        style={{
          fontFamily: 'var(--gt-font-mono)',
          fontSize: '9.5px',
          color: 'var(--gt-text-5)',
          overflowWrap: 'anywhere',
        }}
      >
        <span>{v.invLink}</span>
      </div>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        <span onClick={() => copy(v.invLink, 'INVITE LINK COPIED')} style={CHIP}>
          COPY LINK
        </span>
        <span
          onClick={() => copy(v.invKey + ' / ' + v.invPw + ' — ' + v.invLink, 'CREDENTIALS COPIED')}
          style={CHIP}
        >
          COPY LOGIN + PASSWORD
        </span>
        <span onClick={s.closeInvite} style={{ ...CHIP, color: 'var(--gt-muted)' }}>
          DISMISS
        </span>
      </div>
    </div>
  );
}
